import { Card, Group, Text } from "@mantine/core";
import { IconUsers } from "@tabler/icons-react";

import OverviewFilterCaption from "../common/OverviewFilterCaption";
import OverviewStat from "../common/OverviewStat";

interface UserOverviewCounts {
	total: number;
	active: number;
	admins: number;
	managers: number;
}

interface UserOverviewProps extends UserOverviewCounts {
	// Counts under the page's filters, shown under each total; null unfiltered
	filtered?: UserOverviewCounts | null;
	filterLabel?: string | null;
}

function UserOverview({ total, active, admins, managers, filtered, filterLabel }: UserOverviewProps) {
	return (
		<Card
			shadow="sm"
			padding="lg"
			radius="md"
			withBorder
			mb="lg">
			<Group
				justify="space-between"
				mb="md">
				<Group>
					<IconUsers size={20} />
					<Text fw={500}>User Overview</Text>
				</Group>
				<OverviewFilterCaption label={filtered ? (filterLabel ?? null) : null} />
			</Group>
			<Group>
				<OverviewStat
					value={total}
					label="Total Users"
					filteredValue={filtered?.total}
				/>
				<OverviewStat
					value={active}
					label="Active"
					color="green"
					filteredValue={filtered?.active}
				/>
				<OverviewStat
					value={admins}
					label="Admins"
					color="violet"
					filteredValue={filtered?.admins}
				/>
				<OverviewStat
					value={managers}
					label="Managers"
					color="blue"
					filteredValue={filtered?.managers}
				/>
			</Group>
		</Card>
	);
}

export default UserOverview;
